var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75195 7.58317C9.76507 5.22689 9.86956 3.95082 10.702 3.11841C11.6539 2.1665 13.1859 2.1665 16.2501 2.1665L17.3334 2.1665C20.3975 2.1665 21.9296 2.1665 22.8815 3.11841C23.8334 4.07031 23.8334 5.60237 23.8334 8.6665L23.8334 17.3332C23.8334 20.3973 23.8334 21.9294 22.8815 22.8813C21.9296 23.8332 20.3975 23.8332 17.3334 23.8332L16.2501 23.8332C13.1859 23.8332 11.6539 23.8332 10.702 22.8813C9.86956 22.0489 9.76507 20.7728 9.75195 18.4165",
    stroke: "black",
    strokeWidth: 2.22599,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 13L2.16667 13M2.16667 13L5.95833 9.75M2.16667 13L5.95833 16.25",
    stroke: "black",
    strokeWidth: 2.22599,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLogout);
export default __webpack_public_path__ + "static/media/arrow-logout.9bd532b0d4a600a58214e82f8a9919a7.svg";
export { ForwardRef as ReactComponent };